module.exports = __webpack_public_path__ + "static/jobs-created-map-ce4c1951a5ae45ab2334681a9332081c.png";